import React from 'react';

import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {checkIcon, checkItem} from '../get-started.module.styl';

type WhatYouNeedListProps = {
    items: string[],
};

export const WhatYouNeedList: React.FC<WhatYouNeedListProps> = ({items}) => {
    return (
        <Group direction="v" gap="s">
            {items.map(item => (
                <div key={item} className={checkItem}>
                    <span className={checkIcon}>
                        <Icon type={Icons.CHECK} size="Size_14"/>
                    </span>
                    <Typography variant="body-level-1">{item}</Typography>
                </div>
            ))}
        </Group>
    );
};
